import React from 'react';
import PropTypes from 'prop-types';
import { replace } from '../../utils/func';
import styles from './OrderItemPrice.module.scss';

const OrderItemPrice = ({ orderItem }) => {
  const { product, discountedPrice, discountPercentage, cartQuantity } = orderItem;
  
  // Якщо є знижка (discountPercentage > 0), показуємо обидві ціни
  const hasDiscount = discountPercentage && discountPercentage > 0;
  
  // Оригінальна ціна за одиницю
  const originalPrice = product.currentPrice;
  
  // Ціна зі знижкою за одиницю (з сервера)
  const discountPrice = parseFloat(discountedPrice);
  
  return (
    <div className={styles.priceContainer}>
      {hasDiscount ? (
        <div className={styles.priceWithDiscount}>
          {/* Ціна зі знижкою */}
          <div className={styles.currentPrice}>
            Ціна: {replace(discountPrice)} грн
          </div>
          {/* Оригінальна ціна (закреслена) */}
          <div className={styles.originalPrice}>
            {replace(originalPrice)} грн
          </div>
          {/* Відсоток знижки */}
          <div className={styles.discountBadge}>
            -{Math.round(discountPercentage)}%
          </div>
        </div>
      ) : (
        /* Звичайна ціна без знижки */
        <div className={styles.regularPrice}>
          Ціна: {replace(originalPrice)} грн
        </div>
      )}
      
      {/* Загальна сума за позицію */}
      <div className={styles.totalPrice}>
        Сума: {replace((discountPrice * cartQuantity).toFixed(2))} грн
      </div>
    </div>
  );
};

OrderItemPrice.propTypes = {
  orderItem: PropTypes.shape({
    product: PropTypes.shape({
      currentPrice: PropTypes.number.isRequired,
    }).isRequired,
    discountedPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    discountPercentage: PropTypes.number,
    cartQuantity: PropTypes.number.isRequired,
  }).isRequired,
};

export default OrderItemPrice;